/**
 * @deprecated
 * This module should be slowly removed from repository
 * Replace usage by mixins/tabRefreshable
 */
export default {
  namespaced: true,

  state: {
    activeTab: null,
    items: []
  },

  mutations: {
    SET_ACTIVE_TAB (state, tab) {
      state.activeTab = tab || 0
    },

    SET_ITEMS (state, items) {
      state.items = items || []
      if (state.items.length === 0) {
        state.activeTab = null
      } else {
        state.activeTab = 0
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/tabs.js